import React from "react";
import Player from "react-lottie-player";
import animationData from "../../Assets/animations/empty-chat.json";

const EmptyState: React.FC = () => (
  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    minHeight: 320,
    background: "transparent"
  }}>
    <Player
      loop
      play
      animationData={animationData}
      style={{
        width: 180,
        height: 180,
        marginBottom: 24,
        background: "transparent"
      }}
      rendererSettings={{
        preserveAspectRatio: 'xMidYMid meet'
      }}
    />
    <div style={{
      color: "#e6e6e6",
      fontWeight: 500,
      fontSize: 18,
      lineHeight: 1.45,
      textAlign: "center",
      maxWidth: 320
    }}>
      You don't have any conversations yet.
      <br />
      Start a chat to see your messages here!
    </div>
  </div>
);

export default EmptyState;
